// Fragment "plan entitlements" — what the practice console says about what the plan
// includes: the route guard (admin/entitlements/RequireCapability.jsx), the coming-soon /
// not-in-plan badges (Social's scheduling), the product ceiling (ProductsAdmin), the
// usage meters and add-on names on Billing. Merged by ./index.js.
export default {
  fr: {
    "ent.notInPlan.title": "Non inclus dans votre forfait",
    "ent.notInPlan.body": "Votre forfait actuel ne comprend pas cette fonctionnalité. Changez de forfait depuis Abonnement pour l’utiliser.",
    "ent.notInPlan.cta": "Voir l’abonnement",
    "ent.comingSoon.title": "Bientôt disponible",
    "ent.comingSoon.body": "Cette fonctionnalité n’est pas encore disponible.",
    "ent.comingSoon.eta": "Prévu : {eta}",
    "ent.badge.comingSoon": "Bientôt",
    "ent.badge.notInPlan": "Hors forfait",
    "dom.remove": "Retirer le domaine",
    "dom.removeConfirm": "Retirer {domain} ? Votre site cessera de répondre sur ce domaine.",
    "dom.removed": "Domaine retiré.",
    "dom.planNotice": "Connecter ou vérifier un domaine personnalisé ne fait pas partie de votre forfait. Votre domaine actuel et son statut restent affichés ici.",
    "learn.planNotice": "Créer ou modifier des cours ne fait pas partie de votre forfait. Vos cours restent accessibles à vos élèves ; le suivi et la correction restent dans Parcours, Analytics Learn et Revue de quiz.",
    "tele.planNotice": "Vendre de nouvelles visioconsultations ne fait pas partie de votre forfait. Les consultations déjà réservées restent entièrement gérables ici.",
    "bookingServices.videoPlanNotice": "La prestation en visio n’est pas disponible avec votre forfait. Les services en visio existants restent réservés tels quels.",

    "shop.limitReached": "Vous avez atteint la limite de {limit} produits de votre forfait. Changez de forfait pour en ajouter.",

    "social.statusOpt.draft": "Brouillon",
    "social.statusOpt.scheduled": "Planifié",
    "social.statusOpt.published": "Publié",

    "bill.usage.title": "Utilisation du forfait",
    "bill.usage.bookings": "Réservations ce mois-ci",
    "bill.usage.products": "Produits",
    "bill.usage.ofLimit": "{used} / {limit}",
    "bill.usage.unlimited": "Illimité",
    "bill.usage.usedUnlimited": "{used} · illimité",
    "bill.usage.atLimit": "Limite atteinte",

    "bill.addonName.crm": "CRM",
    "bill.addonName.ai_agent": "Assistant IA",
    "bill.addonName.automation": "Automatisations",
    "bill.addonName.social": "Réseaux sociaux",
    "bill.addonRetiredShort": "Retiré",
    "bill.blocked.withReason": "Le booster n’a pas pu être activé : {reason}. Le support Solunary remboursera le paiement.",
    "bill.blocked.noReason": "Le booster n’a pas pu être activé. Le support Solunary remboursera le paiement.",
    "bill.blocked.reason.notInPlan": "il nécessite une fonctionnalité que votre forfait n’inclut pas",
    "bill.blocked.reason.notBuilt": "la fonctionnalité dont il dépend n’est pas encore disponible",
    "bill.blocked.reason.unavailable": "il n’est plus disponible",
    "bill.boosterRequires": "Nécessite : {capability}",
    "bill.boosterComingSoon": "Bientôt disponible",
    "bill.boosterNotAvailable": "Non disponible avec votre forfait",
    "bill.addonRetired": "Retiré — plus disponible ; le support Solunary le retire de votre facture",
  },
  en: {
    "ent.notInPlan.title": "Not included in your plan",
    "ent.notInPlan.body": "Your current plan does not include this feature. Change your plan from Subscription to use it.",
    "ent.notInPlan.cta": "Go to Subscription",
    "ent.comingSoon.title": "Coming soon",
    "ent.comingSoon.body": "This feature is not available yet.",
    "ent.comingSoon.eta": "Expected: {eta}",
    "ent.badge.comingSoon": "Coming soon",
    "ent.badge.notInPlan": "Not in your plan",
    "dom.remove": "Remove domain",
    "dom.removeConfirm": "Remove {domain}? Your site will stop answering on this domain.",
    "dom.removed": "Domain removed.",
    "dom.planNotice": "Connecting or verifying a custom domain is not part of your plan. Your current domain and its status stay shown here.",
    "learn.planNotice": "Creating or editing courses is not part of your plan. Your courses stay open to your students; following and grading them stays in Pathways, Learn analytics and Quiz reviews.",
    "tele.planNotice": "Selling new video consultations is not part of your plan. Consultations already booked stay fully manageable here.",
    "bookingServices.videoPlanNotice": "Video delivery is not available on your plan. Existing video services keep the bookings they already have.",

    "shop.limitReached": "You have reached your plan's limit of {limit} products. Change your plan to add more.",

    "social.statusOpt.draft": "Draft",
    "social.statusOpt.scheduled": "Scheduled",
    "social.statusOpt.published": "Published",

    "bill.usage.title": "Plan usage",
    "bill.usage.bookings": "Bookings this month",
    "bill.usage.products": "Products",
    "bill.usage.ofLimit": "{used} / {limit}",
    "bill.usage.unlimited": "Unlimited",
    "bill.usage.usedUnlimited": "{used} · unlimited",
    "bill.usage.atLimit": "Limit reached",

    "bill.addonName.crm": "CRM",
    "bill.addonName.ai_agent": "AI assistant",
    "bill.addonName.automation": "Automation",
    "bill.addonName.social": "Social media",
    "bill.addonRetiredShort": "Retired",
    "bill.blocked.withReason": "The booster could not be activated: {reason}. Solunary support will refund the charge.",
    "bill.blocked.noReason": "The booster could not be activated. Solunary support will refund the charge.",
    "bill.blocked.reason.notInPlan": "it needs a feature your plan does not include",
    "bill.blocked.reason.notBuilt": "the feature it needs is not available yet",
    "bill.blocked.reason.unavailable": "it is no longer available",
    "bill.boosterRequires": "Requires: {capability}",
    "bill.boosterComingSoon": "Coming soon",
    "bill.boosterNotAvailable": "Not available on your plan",
    "bill.addonRetired": "Retired — no longer available; Solunary support is removing it from your bill",
  },
  es: {
    "ent.notInPlan.title": "No incluido en tu plan",
    "ent.notInPlan.body": "Tu plan actual no incluye esta función. Cambia de plan desde Suscripción para usarla.",
    "ent.notInPlan.cta": "Ir a Suscripción",
    "ent.comingSoon.title": "Próximamente",
    "ent.comingSoon.body": "Esta función aún no está disponible.",
    "ent.comingSoon.eta": "Previsto: {eta}",
    "ent.badge.comingSoon": "Próximamente",
    "ent.badge.notInPlan": "Fuera de tu plan",
    "dom.remove": "Quitar el dominio",
    "dom.removeConfirm": "¿Quitar {domain}? Tu sitio dejará de responder en este dominio.",
    "dom.removed": "Dominio quitado.",
    "dom.planNotice": "Conectar o verificar un dominio personalizado no forma parte de tu plan. Tu dominio actual y su estado siguen mostrándose aquí.",
    "learn.planNotice": "Crear o editar cursos no forma parte de tu plan. Tus cursos siguen abiertos para tus alumnos; el seguimiento y la corrección siguen en Pathways, Análisis Learn y Revisión quiz.",
    "tele.planNotice": "Vender nuevas videoconsultas no forma parte de tu plan. Las consultas ya reservadas siguen siendo totalmente gestionables aquí.",
    "bookingServices.videoPlanNotice": "La modalidad por vídeo no está disponible en tu plan. Los servicios por vídeo existentes conservan las reservas que ya tienen.",

    "shop.limitReached": "Has alcanzado el límite de {limit} productos de tu plan. Cambia de plan para añadir más.",

    "social.statusOpt.draft": "Borrador",
    "social.statusOpt.scheduled": "Programado",
    "social.statusOpt.published": "Publicado",

    "bill.usage.title": "Uso del plan",
    "bill.usage.bookings": "Reservas este mes",
    "bill.usage.products": "Productos",
    "bill.usage.ofLimit": "{used} / {limit}",
    "bill.usage.unlimited": "Ilimitado",
    "bill.usage.usedUnlimited": "{used} · ilimitado",
    "bill.usage.atLimit": "Límite alcanzado",

    "bill.addonName.crm": "CRM",
    "bill.addonName.ai_agent": "Asistente IA",
    "bill.addonName.automation": "Automatizaciones",
    "bill.addonName.social": "Redes sociales",
    "bill.addonRetiredShort": "Retirado",
    "bill.blocked.withReason": "El booster no se pudo activar: {reason}. El soporte de Solunary reembolsará el cargo.",
    "bill.blocked.noReason": "El booster no se pudo activar. El soporte de Solunary reembolsará el cargo.",
    "bill.blocked.reason.notInPlan": "necesita una función que tu plan no incluye",
    "bill.blocked.reason.notBuilt": "la función que necesita aún no está disponible",
    "bill.blocked.reason.unavailable": "ya no está disponible",
    "bill.boosterRequires": "Requiere: {capability}",
    "bill.boosterComingSoon": "Próximamente",
    "bill.boosterNotAvailable": "No disponible con tu plan",
    "bill.addonRetired": "Retirado — ya no está disponible; el soporte de Solunary lo está quitando de tu factura",
  },
};
